import type { DailyCallStats } from "@repo/common";

export function localDateKey(date: Date): string {
	return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

/** Today and the previous 29 calendar days, never calendar-month boundaries. */
export function last30Days(now = new Date()) {
	const start = new Date(now);
	start.setDate(start.getDate() - 29);
	return { start: localDateKey(start), end: localDateKey(now) };
}

export function summarizeCallStats(
	dailyStats: DailyCallStats[],
	now = new Date(),
) {
	const { start, end } = last30Days(now);
	return dailyStats.reduce(
		(sum, day) => {
			if (day.dateKey < start || day.dateKey > end) return sum;
			sum.callCount += day.totals.overall.callCount;
			sum.durationSeconds += day.totals.overall.durationSeconds;
			return sum;
		},
		{ callCount: 0, durationSeconds: 0 },
	);
}

/** Duration as H:MM:SS, including hours for totals longer than a day. */
export function formatDuration(seconds: number): string {
	const total = Math.max(0, Math.round(seconds));
	return `${Math.floor(total / 3600)}:${String(Math.floor(total / 60) % 60).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
}
